/** Инициалы заказчика для аватара оффера (до 2 букв). */
export function getOfferCustomerInitials(customerName: string): string {
	const parts = customerName.trim().split(/\s+/).filter(Boolean);
	if (!parts.length) return '';
	if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();

	return `${parts[0]![0]}${parts[1]![0]}`.toUpperCase();
}
